import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/external-components/angular-material.module';
import { FlexLayoutModule } from 'ng-flex-layout';
import { SharedModule } from '../../shared/shared.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { ParticlesEditComponent } from './particles-edit.component';
import { ParticlesEditDialogTestEditComponent } from './particles-edit-dialog-test-edit/particles-edit-dialog-test-edit.component';
import { ParticlesEditPatternsDialogComponent } from './particles-edit-patterns-dialog/particles-edit-patterns-dialog.component';
import { ParticlesEditAuditComponent } from './particles-edit-audit.component';
import { MatIconModule } from '@angular/material/icon';
import { ParticlesEditAutomaticSignReportComponent } from './particles-edit-automatic-sign-report/particles-edit-automatic-sign-report.component';
import { ParticlesEditManualSignReportComponent } from './particles-edit-manual-sign-report/particles-edit-manual-sign-report.component';
import { ParticlesEditCreateEquipmentComponent } from './particles-edit-create-equipment/particles-edit-create-equipment.component';


@NgModule({
    declarations: [
        ParticlesEditComponent, ParticlesEditDialogTestEditComponent, ParticlesEditPatternsDialogComponent,ParticlesEditAuditComponent,
        ParticlesEditAutomaticSignReportComponent, ParticlesEditManualSignReportComponent, ParticlesEditCreateEquipmentComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        /* Custom modules */
        AngularMaterialModule,
        SharedModule,
        PipesModule,
        MatIconModule,
        /* Otros */
        FlexLayoutModule
    ],
    exports: [ParticlesEditComponent]
})
export class ParticlesEditModule { }
